import { useLanguage } from "@context/use-language";
import { Button, Typography } from "@dm-4dev/ui";
import clsx from "clsx";
import { TicketCheckIcon } from "lucide-react";

const BACKGROUND_IMG =
  "https://firebasestorage.googleapis.com/v0/b/comu-tob/o/images%2Fabrazo-jesus.jpg?alt=media&token=f86c6b6a-fee2-4499-9962-23e7fcd712e0";

export const CommitmentSuccess = ({ handleBack }: { handleBack?: () => void }) => {
  const { t } = useLanguage();

  return (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "gap-6",
        "text-center",
        "bg-white",
        "w-full",
        "shadow",
        "h-dvh",
        "m-auto",
        "text-center",
        "fixed",
        "top-0",
        "left-0",
        "right-0",
        "bottom-0"
      )}
      style={{
        backgroundImage: `url(${BACKGROUND_IMG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div
        className={clsx(
          "flex",
          "flex-col",
          "gap-4",
          "w-full",
          "justify-center",
          "px-2",
          "items-center",
          "mx-auto",
          "fixed",
          "top-0",
          "bottom-0",
          "left-0",
          "right-0",
          "backdrop-blur-sm",
          "z-20"
        )}
      >
        <div className="w-full flex gap-2 items-center text-center justify-center">
          <TicketCheckIcon size={100} className="text-green-500 drop-shadow-md" />
          <Typography variant="title" className="!text-green-500 !text-4xl drop-shadow-md">
            {t("registrationSuccess")}
          </Typography>
        </div>
        <p className="!text-amber-300 !text-3xl text-left p-4">{`${t("jesusIsWaiting")}!`}</p>
      </div>
      {handleBack && (
        <div className="fixed bottom-0 z-50 w-full p-4">
          <Button onClick={handleBack}>{t("registerAnother")}</Button>
        </div>
      )}
    </div>
  );
};
